import axios, { AxiosRequestConfig } from "axios";

export interface IResponseData<T> {
  code: number;
  data: T;
  message: string;
}

const service = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 5000,
  baseURL: process.env.VUE_APP_BASE_API_PATH,
});

const request = <T>(
  config: AxiosRequestConfig = {}
): Promise<IResponseData<T>> => {
  return new Promise((resolve, reject) => {
    service
      .request<IResponseData<T>>(config)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

const ajax = {
  get<T>(url: string, config?: AxiosRequestConfig): Promise<IResponseData<T>> {
    return request<T>(
      Object.assign({}, config, {
        method: "GET",
        url,
      })
    );
  },
  post<T>(url: string, config: AxiosRequestConfig): Promise<IResponseData<T>> {
    return request<T>(
      Object.assign({}, config, {
        method: "POST",
        url,
      })
    );
  },
};

export default ajax;
